import { PayloadAction } from '@reduxjs/toolkit'
import { AuthSliceState, CompleteInfoState, Credentials, PersonalDetails, rolType, UserRols } from 'src/core/models'
import { initialState } from './state'

const reducers = {
  /* Register User Reducers */
  setRegisterStep: (state: AuthSliceState, action: PayloadAction<number>) => {
    state.register.step = action.payload
  },
  resetRegisterState: (state: AuthSliceState) => {
    state.register = initialState.register
  },
  // Credentials Reducers
  setCredentials: (state: AuthSliceState, action: PayloadAction<Credentials>) => {
    state.register.credentials = action.payload
  },
  setRol: (state: AuthSliceState, action: PayloadAction<rolType>) => {
    state.register.rol = action.payload
  },
  setPersonalDetails: (state: AuthSliceState, action: PayloadAction<PersonalDetails>) => {
    state.register.personalDetails = action.payload
  },
  setUserCredentialsEmail: (state: AuthSliceState, action: PayloadAction<string>) => {
    state.register.credentials.email = action.payload
  },
  setUserCompanyName: (state: AuthSliceState, action: PayloadAction<string>) => {
    state.register.personalDetails.companyName = action.payload
  },
  setUserPhone: (state: AuthSliceState, action: PayloadAction<string>) => {
    state.register.personalDetails.phone = action.payload
  },
  setUserCountry: (state: AuthSliceState, action: PayloadAction<number>) => {
    state.register.personalDetails.country = action.payload
  },
  setPersonalDetailsFirstName: (state: AuthSliceState, action: PayloadAction<string>) => {
    state.register.personalDetails.firstName = action.payload
  },
  setPersonalDetailsLastName: (state: AuthSliceState, action: PayloadAction<string>) => {
    state.register.personalDetails.lastName = action.payload
  },
  setUserRols: (state: AuthSliceState, action: PayloadAction<UserRols>) => {
    state.register.rols = action.payload
  },
  setUserIsProducer: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.register.rols.isProducer = action.payload
  },
  setUserIsWidget: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.register.rols.isWidget = action.payload
  },
  setUserhasCommercialCommunications: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.register.rols.hasCommercialCommunications = action.payload
  },
  // Create User Reducers
  setCreateUserLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.register.create.loading = action.payload
  },
  setCreateUserSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.register.create.success = action.payload
  },
  setCreateUserError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.register.create.error = action.payload
  },
  resetCreateUserState: (state: AuthSliceState) => {
    state.register.create = initialState.register.create
  },
  // Forgot Password Reducers
  setForgotPasswordLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.forgotPassword.loading = action.payload
  },
  setForgotPasswordSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.forgotPassword.success = action.payload
  },
  setForgotPasswordError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.forgotPassword.error = action.payload
  },
  resetForgotPasswordState: (state: AuthSliceState) => {
    state.forgotPassword = initialState.forgotPassword
  },
  // Restore Password Reducers
  setRestorePasswordLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.restorePassword.loading = action.payload
  },
  setRestorePasswordSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.restorePassword.success = action.payload
  },
  setRestorePasswordError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.restorePassword.error = action.payload
  },
  resetRestorePasswordState: (state: AuthSliceState) => {
    state.restorePassword = initialState.restorePassword
  },
  // Login Reducers
  setLoginLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.login.loading = action.payload
  },
  setLoginSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.login.success = action.payload
  },
  setLoginError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.login.error = action.payload
  },
  resetLoginState: (state: AuthSliceState) => {
    state.login = initialState.login
  },
  // Verify Email Reducers
  setVerifyEmailLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.verifyEmail.loading = action.payload
  },
  setVerifyEmailSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.verifyEmail.success = action.payload
  },
  setVerifyEmailError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.verifyEmail.error = action.payload
  },
  resetVerifyEmailState: (state: AuthSliceState) => {
    state.verifyEmail = initialState.login
  },

  // Complete Register Reducers
  setCompleteRegisterFormValue: (state: AuthSliceState, action: PayloadAction<{
    key: keyof CompleteInfoState , value: number | boolean | string
  }>) => {
    state.completeInfo[String(action.payload.key)] = action.payload.value
  },
  setCompleteUserInfoLoading: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.completeInfoSubmit.loading = action.payload
  },
  setCompleteUserInfoSuccess: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.completeInfoSubmit.success = action.payload
  },
  setCompleteUserInfoError: (state: AuthSliceState, action: PayloadAction<any>) => {
    state.completeInfoSubmit.error = action.payload
  },
  resetCompleteUserInfoSubmitState: (state: AuthSliceState) => {
    state.completeInfoSubmit = initialState.completeInfoSubmit
  },
  resetCompleteUserState: (state: AuthSliceState) => {
    state.completeInfo = initialState.completeInfo
  },

  // Veirfy Token reducers
  setVerifyTokenRedirectLogin: (state: AuthSliceState, action: PayloadAction<boolean>) => {
    state.verifyToken.redirectLogin = action.payload
  },
}

export default reducers
